var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[_vm.name],attrs:{"width":_vm.viewWidth,"height":_vm.viewHeight,"viewBox":`0 0 ${_vm.viewWidth} ${_vm.viewHeight}`}},_vm._l((_vm.dots),function(dot,index){return _c('circle',{key:index,attrs:{"cx":dot.cx,"cy":dot.cy,"r":dot.radius,"fill":"currentColor","opacity":Math.random() * (1 - 0.2) + 0.2}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }